/**
 * Auto-add Founding Member Bundle when Alfred Slat Kit is added to cart
 * TEMPORARY PROMOTION - Remove this file after 150 founder bundles sold
 * For toronto.alfredslats.com
 */

(function() {
  'use strict';

  const CONFIG = {
    triggerProductTitles: [
      'Alfred Slat Kit',
      'Three Car Garage',
      'Two Car Garage',
      'Single Garage'
    ],
    bundleProductHandle: 'founding-member-bundle',
    discountCode: 'founder',
    popupDuration: 2000
  };

  let isProcessing = false;
  let lastRefreshTime = 0;

  // Extract pack size from variant title (8 Pack, 16 Pack, 20 Pack, etc.)
  function getPackSize(variantTitle) {
    if (!variantTitle) return 1;
    
    const packMatch = variantTitle.match(/(\d+)\s+Pack/i);
    if (packMatch) {
      return parseInt(packMatch[1]);
    }
    
    return 1;
  }

  function showPopup(message, type = 'success') {
    const existingPopup = document.querySelector('.founder-bundle-popup');
    if (existingPopup) existingPopup.remove();

    const popup = document.createElement('div');
    popup.className = `founder-bundle-popup founder-bundle-popup--${type}`;
    popup.innerHTML = `
      <div class="founder-bundle-popup__content">
        <svg class="founder-bundle-popup__icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm1 15H9v-2h2v2zm0-4H9V5h2v6z" fill="currentColor"/>
        </svg>
        <span class="founder-bundle-popup__message">${message}</span>
        <button class="founder-bundle-popup__close" aria-label="Close">&times;</button>
      </div>
    `;

    const style = document.createElement('style');
    style.textContent = `
      .founder-bundle-popup {
        position: fixed;
        top: 20px;
        right: 20px;
        background: #ffffff;
        border: 2px solid #10b981;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        padding: 16px 20px;
        z-index: 9999;
        max-width: 400px;
        animation: slideIn 0.3s ease-out;
      }
      .founder-bundle-popup--error {
        border-color: #ef4444;
      }
      .founder-bundle-popup__content {
        display: flex;
        align-items: center;
        gap: 12px;
      }
      .founder-bundle-popup__icon {
        flex-shrink: 0;
        color: #10b981;
      }
      .founder-bundle-popup--error .founder-bundle-popup__icon {
        color: #ef4444;
      }
      .founder-bundle-popup__message {
        flex: 1;
        font-size: 14px;
        line-height: 1.4;
        color: #1f2937;
        font-weight: 500;
      }
      .founder-bundle-popup__close {
        background: none;
        border: none;
        font-size: 24px;
        line-height: 1;
        cursor: pointer;
        color: #6b7280;
        padding: 0;
        margin-left: 8px;
        transition: color 0.2s;
      }
      .founder-bundle-popup__close:hover {
        color: #1f2937;
      }
      @keyframes slideIn {
        from {
          transform: translateX(400px);
          opacity: 0;
        }
        to {
          transform: translateX(0);
          opacity: 1;
        }
      }
      @media (max-width: 640px) {
        .founder-bundle-popup {
          top: 10px;
          right: 10px;
          left: 10px;
          max-width: none;
        }
      }
    `;

    document.head.appendChild(style);
    document.body.appendChild(popup);

    popup.querySelector('.founder-bundle-popup__close').addEventListener('click', () => popup.remove());
    setTimeout(() => { if (popup.parentElement) popup.remove(); }, CONFIG.popupDuration);
  }

  async function getProductVariantId(handle) {
    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) throw new Error(`Product not found: ${handle}`);
      const product = await response.json();
      return product?.variants?.[0]?.id || null;
    } catch (error) {
      console.error('[Founder Bundle] Error fetching product:', error);
      return null;
    }
  }

  async function getCartData() {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) throw new Error('Failed to fetch cart');
      const cart = await response.json();
      
      // Calculate total packs from all matching products
      let totalPacks = 0;
      cart.items.forEach(item => {
        if (CONFIG.triggerProductTitles.some(title => item.product_title.startsWith(title))) {
          const packsPerUnit = getPackSize(item.variant_title);
          totalPacks += packsPerUnit * item.quantity;
          console.log(`[Founder Bundle] Found: ${item.product_title} - ${item.variant_title} = ${packsPerUnit} packs x ${item.quantity} qty = ${packsPerUnit * item.quantity} total`);
        }
      });
      
      const bundleItem = cart.items.find(item => 
        item.handle === CONFIG.bundleProductHandle
      );
      const bundleQty = bundleItem ? bundleItem.quantity : 0;
      const bundleVariantId = bundleItem ? bundleItem.variant_id : null;

      console.log(`[Founder Bundle] Total packs in cart: ${totalPacks}, Current bundles: ${bundleQty}`);

      return { 
        cart, 
        slatKitQty: totalPacks,
        bundleQty, 
        bundleVariantId,
        hasSlatKit: totalPacks > 0,
        hasBundle: bundleQty > 0
      };
    } catch (error) {
      console.error('[Founder Bundle] Error fetching cart data:', error);
      return { 
        cart: null, 
        slatKitQty: 0, 
        bundleQty: 0, 
        bundleVariantId: null,
        hasSlatKit: false,
        hasBundle: false
      };
    }
  }

  async function forceReloadCartDrawer() {
    await new Promise(resolve => setTimeout(resolve, 200));
    
    if (window.location.pathname === '/cart') {
      console.log('[Founder Bundle] Reloading cart page');
      window.location.reload();
      return;
    }
    
    try {
      const timestamp = Date.now();
      console.log('[Founder Bundle] 🔄 Fetching fresh cart drawer HTML');
      
      const response = await fetch(window.location.pathname + `?sections=cart-drawer&t=${timestamp}`, {
        method: 'GET',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      });
      
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }
      
      const data = await response.json();
      console.log('[Founder Bundle] ✅ Fresh HTML received');
      
      if (data && data['cart-drawer']) {
        const cartDrawerContent = document.querySelector('#cart-drawer-content');
        if (cartDrawerContent) {
          const temp = document.createElement('div');
          temp.innerHTML = data['cart-drawer'];
          const newContent = temp.querySelector('#cart-drawer-content');
          
          if (newContent) {
            cartDrawerContent.innerHTML = newContent.innerHTML;
            console.log('[Founder Bundle] ✅ Badge should now be visible!');
            lastRefreshTime = Date.now();
          }
        }
      }
    } catch (error) {
      console.error('[Founder Bundle] ❌ Refresh failed:', error);
    }
  }

  async function syncFounderBundle() {
    if (isProcessing) return;
    isProcessing = true;

    try {
      const { slatKitQty, bundleQty, bundleVariantId, hasSlatKit, hasBundle } = await getCartData();

      console.log(`[Founder Bundle] Total Packs: ${slatKitQty}, Bundles: ${bundleQty}`);

      const installCheckbox = document.getElementById('alfred-install-addon');
      const isCheckboxChecked = installCheckbox ? installCheckbox.checked : false;
      
      const cart = await fetch('/cart.js').then(r => r.json());
      const installItem = cart.items.find(item => item.variant_id === parseInt('51365904679223'));
      const installQty = installItem ? installItem.quantity : 0;
      const userWantsInstallation = isCheckboxChecked || installQty > 0;

      const updates = {};

      if (userWantsInstallation && hasSlatKit && installQty !== slatKitQty) {
        console.log(`[Founder Bundle] Also syncing installation from ${installQty} to ${slatKitQty}`);
        updates['51365904679223'] = slatKitQty;
      } else if (!userWantsInstallation && installQty > 0) {
        console.log(`[Founder Bundle] Removing installation (user unchecked)`);
        updates['51365904679223'] = 0;
      } else if (!hasSlatKit && installQty > 0) {
        console.log(`[Founder Bundle] Removing installation (no slat kits)`);
        updates['51365904679223'] = 0;
      }

      if (!hasSlatKit && hasBundle) {
        console.log('[Founder Bundle] Removing bundles (no slat kits)');
        updates[bundleVariantId] = 0;
      }

      if (hasSlatKit && bundleQty !== slatKitQty) {
        if (!hasBundle) {
          const variantId = await getProductVariantId(CONFIG.bundleProductHandle);
          if (!variantId) {
            showPopup('Unable to add Founding Member Bundle. Please contact support.', 'error');
            isProcessing = false;
            return;
          }

          if (Object.keys(updates).length > 0) {
            await fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates })
            });
          }

          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: slatKitQty }] })
          });
          
          showPopup(`🎉 ${slatKitQty} FREE Founding Member Bundle${slatKitQty > 1 ? 's' : ''} added to your cart! (Value: $${50 * slatKitQty})`);
          
          sessionStorage.setItem('founder_discount_code', CONFIG.discountCode);
          
          await forceReloadCartDrawer();
        } else {
          if (bundleQty > slatKitQty) {
            console.log(`[Founder Bundle] Capping from ${bundleQty} to ${slatKitQty} (can't exceed packs)`);
          } else {
            console.log(`[Founder Bundle] Syncing from ${bundleQty} to ${slatKitQty}`);
          }
          
          updates[bundleVariantId] = slatKitQty;
        }
      }

      if (Object.keys(updates).length > 0 && hasBundle) {
        console.log('[Founder Bundle] Applying updates:', updates);
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
        
        await forceReloadCartDrawer();
      } else if (Object.keys(updates).length > 0 && !hasSlatKit) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
        await forceReloadCartDrawer();
      }

    } catch (error) {
      console.error('[Founder Bundle] Error:', error);
      showPopup('Something went wrong. Please try adding the bundle manually.', 'error');
    }

    isProcessing = false;
  }

  async function checkAndRefreshBadge() {
    const drawer = document.querySelector('#cart-drawer-content');
    
    if (!drawer || !drawer.offsetParent) {
      return;
    }

    if (Date.now() - lastRefreshTime < 2000) {
      return;
    }

    const { hasBundle } = await getCartData();
    if (!hasBundle) {
      return;
    }

    const badge = document.querySelector('.founder-badge');
    if (badge) {
      return;
    }

    console.log('[Founder Bundle] 🎯 Drawer visible but badge missing - refreshing!');
    await forceReloadCartDrawer();
  }

  function init() {
    console.log('[Founder Bundle] Initialized - TEMPORARY until 150 sold');

    setTimeout(syncFounderBundle, 400);

    setInterval(checkAndRefreshBadge, 1000);

    const originalFetch = window.fetch;
    window.fetch = function(...args) {
      const promise = originalFetch.apply(this, args);
      
      if (args[0] && (
        args[0].includes('/cart/add') || 
        args[0].includes('/cart/change') || 
        args[0].includes('/cart/update')
      )) {
        promise.then(() => {
          setTimeout(syncFounderBundle, 500);
        });
      }
      
      return promise;
    };

    setInterval(() => {
      if (!isProcessing) {
        syncFounderBundle();
      }
    }, 3000);

    document.addEventListener('click', (e) => {
      const target = e.target.closest('a[href*="/checkout"]');
      if (target && target.tagName === 'A') {
        const code = sessionStorage.getItem('founder_discount_code');
        if (code) {
          e.preventDefault();
          const url = new URL(target.href);
          url.searchParams.set('discount', CONFIG.discountCode);
          window.location.href = url.toString();
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();